<template>
  <div class="news-list">
    <h2>发表的文章</h2>
    <div v-for="item in list" :key="item.newsId" class="news-item items-center hand" @click="toDetails(item)">
      <img :src="item.newsImage" />
      <div class="info">
        <!-- <time>{{ item.releaseTime }}</time> -->
        <h3>{{ item.newsTitle }}</h3>
        <p v-html="item.brief"></p>
        <div class="tag">
          <span>{{ item.tag }}{{ item.linkMagazine ? ' · ' + item.linkMagazine : '' }}</span>
          <em>{{ item.linkMagazine ? L('摘自' + item.linkMagazine) : '' }}</em>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsList } from "@/assets/api/news.js";
export default {

  props: {
    authorId: {
      type: String,
    }
  },

  watch: {
    authorId() {
      this.getList()
    }
  },

  data() {
    return {
      list: [],
    }
  },

  mounted() {
    this.getList();
  },

  methods: {
    getList() {
      if (!this.authorId) return;

      getNewsList({
        orderByColumn: "releaseTime",
        isAsc: "desc",
        pageNum: 1,
        pageSize: 5,
        slideshow: 0,
        authorId: this.authorId,
      }).then((res) => {
        if (res.data && res.data.rows && Array.isArray(res.data.rows)) {
          this.list = res.data.rows.map((item) => {
            item.newsImage = !/^http/.test(item.newsImage)
              ? this.$imgUrl + item.newsImage
              : item.newsImage;
            item.tag = item.tag ? item.tag.split('|').join(' · ') : '';
            return item;
          });
        } else {
          this.list = [];
        }
      });

    },
    generateSlug(title) {
      // 将标题中的空格替换为连字符
      let slug = title.toLowerCase().replace(/\s+/g, '-');
      // 将连字符替换为单个连字符
      slug = slug.replace(/-+/g, '');
      slug = slug.replace(/:+/g, '');
      return slug;
    },
    toDetails(item) {
      console.log(this.$route.path)
      if (item.url) {
        window.open(item.url, "_blank");
      } else {
        if (item.price > 0) {
          const path = `/expert-details/${item.newsId}`;
          if (this.$route.path.indexOf('/expert-details') === 0) {
            this.$router.replace({
              path,
            });
          } else {
            this.$router.push({
              path,
            });
          }
        } else {
          localStorage.setItem('newsId', item.newsId);
          let path = item.seoUrl ? item.seoUrl : item.newsId
          this.$router.push({
            path: `/${path}.html`,
          });
          path = `/${path}.html`;

          // const path = `/article-details/${item.newsId}`;
          if (this.$route.path.indexOf('/article-details') === 0) {
            this.$router.replace({
              path,
            });
          } else {
            this.$router.push({
              path,
            });
          }


        }
      }
    },


  }
}
</script>

<style lang="less" scoped>
.news-list {
  h2 {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 32px;
    color: #2C2C2E;
    line-height: 42px;
    text-align: left;
    font-style: normal;
    padding: 40px 0 30px;
    border-bottom: 1px solid #E5E5EA;
  }

  .news-item {
    padding: 30px 0;
    border-bottom: 1px solid #E5E5EA;


    img {
      width: 200px;
      height: 128px;
      border-radius: 8px;
      object-fit: cover;
      margin-right: 16px;
    }

    h3 {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 24px;
      color: #2C2C2E;
      line-height: 31px;
      text-align: left;
      font-style: normal;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
    }

    p {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #636366;
      line-height: 21px;
      text-align: justify;
      font-style: normal;
      margin-top: 8px;

      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;

    }

    .tag {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #AEAEB2;
      line-height: 19px;
      text-align: left;
      font-style: normal;

      em {
        color: #E2291E;
      }
    }

    &:hover {
      h3 {
        color: #E2291E;
      }

    }
  }

}


@media screen and (max-width: 768px) {
  .news-list {
    padding: 15px;

    h2 {
      font-family: NotoSansCJKTC;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 29px;
      letter-spacing: normal;
      text-align: left;
      color: #222;
      padding: 6px 0;
      margin-top: 15px;
      margin-bottom: 20px;
      border-bottom: 1px solid #e13133;
    }

    .news-item {
      margin-bottom: 10px;

      img {
        width: 100px;
        height: 100px;
        object-fit: cover;
        margin-right: 10px;
      }

      time {
        font-family: NotoSansCJKTC;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.71;
        letter-spacing: 0.7px;
        text-align: center;
        color: #8b8b8b;
        margin-bottom: 2px;
      }

      h3 {
        font-family: NotoSansCJKTC;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: 2.4px;
        text-align: left;
        color: #222;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/article-details/components/related-article.vue